import Api from './ApiService'

export default {
    get(keyword, pageNumber, filters, order) {
        const params = new URLSearchParams();

        params.append('keyword', keyword);
        params.append('pageNumber', pageNumber);
        params.append('orderColumn', order.column);
        params.append('orderSort', order.sort);

        Object.keys(filters).forEach(key => {
            filters[key].forEach(value => {
                params.append(`${key}[]`, value);
            });
        });

        return Api().get(`admins`, { params });
    },
    export(keyword, filters, order) {
        const params = new URLSearchParams();
        params.append('keyword', keyword);
        params.append('export', true);
        params.append('orderColumn', order.column);
        params.append('orderSort', order.sort);

        Object.keys(filters).forEach(key => {
            filters[key].forEach(value => {
                params.append(`${key}[]`, value);
            });
        });

        return Api().get('admins', {
            params,
            responseType: 'blob'
        });
    },
    getOne(id) {
        return Api().get(`admins/${id}`);
    },
    // Lista enxuta para o seletor de destinatários de teste (traz phone_wa).
    listAll() {
        return Api().get('admins', {
            params: { keyword: '', pageNumber: 1, pageSize: 1000, orderColumn: 'firstName', orderSort: 'ASC' }
        });
    },
    create(data) {
        return Api().post('admins', data);
    },
    update(id, data) {
        return Api().put(`admins/${id}`, data);
    },
    updatePermissions(id, data) {
        return Api().put(`admins/${id}/permissions`, data);
    },
    // Catálogo real de permissões (tabela permissions do backend)
    getPermissions() {
        return Api().get('admins/permissions');
    },
    // Permissões do admin logado (esconde telas/ações sem acesso)
    getMyPermissions() {
        return Api().get('admins/me/permissions');
    }
}